var map = {
	"./de/video-btn.png": "TqBv",
	"./en/video-btn.png": "uV6q",
	"./es/video-btn.png": "cs3N",
	"./fr/video-btn.png": "8epg",
	"./ja/video-btn.png": "4WI3",
	"./ko/video-btn.png": "kjEA",
	"./pt/video-btn.png": "OZqK",
	"./ru/video-btn.png": "p6WM",
	"./tc/video-btn.png": "FYrO",
	"./th/video-btn.png": "CLPa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "S6k8";